var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.metrics, null, 2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }